'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../node_modules/@babel/runtime/helpers/esm/extends.js');

var defineProperty = require('../../node_modules/@babel/runtime/helpers/esm/defineProperty.js');

var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var React = require('react');

var index = require('../../node_modules/prop-types/index.js');

var index$1 = require('../../node_modules/classnames/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var _excluded = ["className", "tag", "cascade", "wide", "narrow", "reverse", "testimonial", "ecommerce", "collection", "pricing", "personal", "news", "color", "text", "border"];

var Card = function Card(props) {
  var _classNames;

  var className = props.className,
      Tag = props.tag,
      cascade = props.cascade,
      wide = props.wide,
      narrow = props.narrow,
      reverse = props.reverse,
      testimonial = props.testimonial,
      ecommerce = props.ecommerce,
      collection = props.collection,
      pricing = props.pricing,
      personal = props.personal,
      news = props.news,
      color = props.color,
      text = props.text,
      border = props.border,
      attributes = objectWithoutProperties['default'](props, _excluded);
  var classes = index$1['default']((_classNames = {
    'card-cascade': cascade,
    'card-cascade wider': wide,
    'card-cascade narrower': narrow,
    'card-cascade wider reverse': reverse,
    'testimonial-card': testimonial,
    'card-ecommerce': ecommerce,
    'collection-card': collection,
    'pricing-card': pricing,
    'card-personal': personal,
    'news-card': news
  }, defineProperty['default'](_classNames, "".concat(text, "-text"), text), defineProperty['default'](_classNames, "border-".concat(border), border), _classNames), 'card', 'lanl-card', color, className);
  return /*#__PURE__*/React__default['default'].createElement(Tag, _extends['default']({
    "data-testid": "card"
  }, attributes, {
    className: classes
  }));
};

Card.propTypes = {
  border: index['default'].string,
  cascade: index['default'].bool,
  className: index['default'].string,
  collection: index['default'].bool,
  color: index['default'].string,
  ecommerce: index['default'].bool,
  narrow: index['default'].bool,
  news: index['default'].bool,
  personal: index['default'].bool,
  pricing: index['default'].bool,
  reverse: index['default'].bool,
  tag: index['default'].string,
  testimonial: index['default'].bool,
  text: index['default'].string,
  wide: index['default'].bool
};
Card.defaultProps = {
  tag: 'div'
};
exports.Card = Card;
exports['default'] = Card;